export default "__VITE_ASSET__afaa7fd3__"